import React from 'react';
import { Route, Switch } from 'react-router-dom';
import {
    AllMyContributions,
    ContributionsGlobalView,
    Error404,
} from '../domains';

const ContributionsRoutes = () => (
    <Switch>
        <Route
            exact
            path="/contributions/my-contributions"
            component={AllMyContributions}
        />
        <Route
            exact
            path="/contributions/global-view"
            component={ContributionsGlobalView}
        />
        <Route component={Error404} />
    </Switch>
);

export default ContributionsRoutes;
